import { FETCH_STATISTICS } from "actions"

const initState = {
}

export default function (state = initState, action) {
  switch (action.type) {

    case FETCH_STATISTICS: {
      return action.payload.data();
    }

    default:
      return state
  }
}